import type { RouteRecordRaw } from 'vue-router'

import { registerImpactMessages } from './i18n'

import { useLocaleStore } from '@/shared/i18n'

export const IMPACT_ANALYSIS_ROUTE = { name: 'ImpactAnalysis' } as const
export const IMPACT_ANALYSIS_DETAIL_ROUTE = { name: 'ImpactAnalysisDetail' } as const

export const impactRoutes: RouteRecordRaw[] = [
  {
    path: 'impact-analysis',
    name: IMPACT_ANALYSIS_ROUTE.name,
    component: () => import('./components/ImpactAnalysisPage.vue'),
    meta: {
      requiresAuth: true,
      permission: 'flag:causal_impact',
      navKey: 'impactAnalysis',
      titleKey: 'impactAnalysis.page.title',
      contentInset: 'none',
    },
    beforeEnter: () => registerImpactMessages(useLocaleStore().locale),
  },
  {
    path: 'impact-analysis/:executionId',
    name: IMPACT_ANALYSIS_DETAIL_ROUTE.name,
    component: () => import('./components/results/ImpactAnalysisDetailPage.vue'),
    meta: {
      requiresAuth: true,
      permission: 'flag:causal_impact',
      titleKey: 'impactAnalysis.page.title',
      contentInset: 'none',
    },
    beforeEnter: () => registerImpactMessages(useLocaleStore().locale),
  },
]
